import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Checkbox,
  Collapse,
  List,
  Tooltip,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { ApprovalConfigurationStageApprover, APPROVER_TYPE, EmployeeOption, GroupOption } from '../../types';
import useStyles from './dialog.styles';

export interface Props {
  approver: ApprovalConfigurationStageApprover
  index: number
  isActionable: boolean
  onIsOptionalChange: (approverId: string, isOptional: boolean) => void
  onDelete: (index: number) => void
  availableApprovers: EmployeeOption[]
  selectedGroups: GroupOption[]
}

const ApproverRow: React.FC<Props> = ({
  approver,
  index,
  isActionable,
  onIsOptionalChange,
  onDelete,
  availableApprovers,
  selectedGroups,
}) => {
  const classes = useStyles();

  const approverDetails = availableApprovers.find(item => item.id === approver.id);
  const approverName = approverDetails?.name ?? approver.name;

  const groupDetails = selectedGroups.find(item => item.id === approver.id);
  const employeeCount = groupDetails?.joinedEmployees?.length;

  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

  return (
    <div className={classes.tableRow}>
      <div className={classes.tableCellSerialNum}>
        {index + 1}.
      </div>
      <div className={classes.tableCellOne}>
        { approver.type === APPROVER_TYPE.USER
          ? <Typography variant="body1" className={classes.approverName}>{approverName}</Typography>
          : <></> }
        { approver.type === APPROVER_TYPE.GROUP
          ? <>
            <Box className={classes.groupHeader}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded
                ? <FontAwesomeIcon icon={solid('minus')} className={classes.groupExpandIcon} />
                : <FontAwesomeIcon icon={solid('add')} className={classes.groupExpandIcon} />
              }
              <Box>
                <Typography variant="body1" className={classes.groupName}>
                  {approverName}
                </Typography>

                <Typography variant="body2" className={classes.groupDetails}>
                  {employeeCount} Employees
                </Typography>
              </Box>
            </Box>
            <Collapse in={isExpanded}>
              <List className={classes.employeeList}>
                {groupDetails?.joinedEmployees.map((employee) => (
                  <Typography
                    key={employee.id}
                    variant="body2"
                    className={classes.employeeName}
                  >
                    {employee.user?.name}
                  </Typography>
                ))}
              </List>
            </Collapse>
          </>
          : <></> }
      </div>
      <div className={classes.tableCellTwo}>
        <Tooltip
          title={approver.isOptional ? 'Optional approver' : 'Required approver'}>
          <Checkbox
            checked={!approver.isOptional}
            disabled={!isActionable}
            onChange={(e) =>
              onIsOptionalChange(
                approver.id,
                !e.target.checked,
              )
            }
          />
        </Tooltip>
      </div>
      <div className={classes.tableCellSerialNum}>
        { isActionable && <FontAwesomeIcon icon={solid('trash-can')} onClick={() => onDelete(index)} className={classes.deleteIcon} /> }
      </div>
    </div>
  );
};

export default ApproverRow;
